import { useMemo } from "react";
import * as Endpoint from "../../../endpoints";

import IFormType from "../../interfaces/IFormType";
import { useAuthContext } from "../../auth/AuthenticationProvider";
import IFormDefinition from "../../interfaces/IFormDefinition";
import { getSgApiService } from "../../../sg-core/services/ApiService2";
import { getContextService } from "../../services/contextService";
import { AuditoinnitCacheKeys } from "../cacheKeys";
import { useSWROffline } from "../../../sg-core/swr/useSWROffline";

export type IUseFormTypeHook = (formTypeId: IFormType["id"]) => {
    data: IFormDefinition | null;
    fetching: boolean;
}

export const useFormDefinition: IUseFormTypeHook = (formTypeId) => {
    const { token, lang, anonymousSession } = useAuthContext();
    const service = getContextService(getSgApiService(token), Endpoint.auditoinnit, anonymousSession);


    const fetcher = async (): Promise<IFormDefinition> => {

        const initialData = await service.getFormDefinition(formTypeId);
        if (initialData.isFailure) {
            throw initialData.error;
        }
        if (!initialData.value || !initialData.value.schema) {
            throw Error("Schema is missing!");
        }
        const mockDefinition = { ...initialData.value };
        if (process.env.NODE_ENV !== "production") {
            //  mockDefinition.schema = require("../../../@schemas/kerava_vapaakierros.json")
        }
        return mockDefinition;
    };

    const cacheKey = AuditoinnitCacheKeys(token, lang).FormDefinitionInstance(formTypeId);
    const { data, isValidating } = useSWROffline(
        cacheKey,
        fetcher,
        { suspense: true, revalidateOnFocus: false, revalidateOnMount: false }
    );


    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating
    }), [rawData, isValidating]);
};
